import { CustomViewEntity } from 'src/graphql/entities/custom-view';
import { EntityNames } from 'src/graphql/types';

// Lucide names, stored verbatim on `custom_view.icon`. Names must exist in LUCIDE_ICONS.
export const CUSTOM_VIEWS_AVAILABLE_ICONS = [
  'inbox',
  'layers',
  'clipboard-check',
  'list-checks',
  'home',
  'id-card',
  'users',
  'line-chart',
  'alert-circle',
  'calendar-clock',
  'alert-octagon',
  'bar-chart-3',
  'trending-up',
  'move-right',
  'calendar-check',
  'flag',
  'gallery-horizontal-end',
  'package',
  'hourglass',
  'headphones',
  'bug',
  'alert-triangle',
  'check-circle',
  'sparkles',
  'tag',
  'calendar-days',
  'shield-check',
  'globe',
  'thermometer',
  'zap',
  'dollar-sign',
  'layout-dashboard',
  'pin',
  'folder',
];

export const MAP_URL_ENTITY_NAME_TO_ENTITY = {
  conversations: EntityNames.Conversation,
  projects: EntityNames.Project,
  sites: EntityNames.Site,
  clients: EntityNames.Client,
} as Record<string, CustomViewEntity>;

export const MAP_ENTITY_TO_URL_ENTITY: Record<CustomViewEntity, string> = Object.entries(
  MAP_URL_ENTITY_NAME_TO_ENTITY,
).reduce(
  (acc, [to, from]) => ({ ...acc, [from]: to }),
  {} as Record<CustomViewEntity, string>,
);

export const PLATFORM_PARTNER_HIDDEN_VIEW_TABS: CustomViewEntity[] = [EntityNames.Client];
